(() => {
  'use strict';
  function openPreorder(model) {
    const select = document.getElementById('preorder-ipad');
    if (select && model) {
      const option = Array.from(select.options).find(o => o.dataset.modelId === model.id);
      if (option) select.value = option.value;
    }
    document.getElementById('launch')?.scrollIntoView({ behavior: 'smooth' });
    select?.focus({ preventScroll: true });
  }
  document.addEventListener('aerodock:interest', event => openPreorder(event.detail?.model));
  let opener = null;
  function closeFilm() {
    const dialog = document.getElementById('aerodock-film');
    dialog?.querySelector('video')?.pause();
    if (dialog?.open) dialog.close();
    opener?.focus();
  }
  document.addEventListener('click', event => {
    const bundle = event.target.closest('[data-register-bundle]');
    if (bundle) { event.preventDefault(); openPreorder(null); }
    const open = event.target.closest('[data-open-film]');
    if (open) {
      const dialog = document.getElementById('aerodock-film');
      if (dialog) { opener = open; dialog.showModal(); dialog.querySelector('video')?.play().catch(() => {}); }
    }
    if (event.target.closest('[data-close-film]')) closeFilm();
    const dialog = document.getElementById('aerodock-film');
    if (event.target === dialog && dialog?.open) {
      const r = dialog.getBoundingClientRect();
      if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) closeFilm();
    }
  });

  function initialise() {
    const dialog = document.getElementById('aerodock-film');
    if (dialog && !dialog.dataset.aerodockBound) {
      dialog.dataset.aerodockBound = 'true';
      dialog.addEventListener('close', () => dialog.querySelector('video')?.pause());
      dialog.addEventListener('cancel', () => dialog.querySelector('video')?.pause());
    }
  }
  initialise();
  document.addEventListener('shopify:section:load', initialise);
})();
